import { useEffect } from "react";
import { useRouter } from "next/router";
//
import { useSelector } from "./redux";

/**
 * redirects from the current page to the previous or the default (plans) after successful authentication
 */
export default function useRedirectAfterAuth(): void {
    const router = useRouter();
    const isAuthenticated = useSelector(
        (state) => state.authReducer.isAuthenticated
    );

    function handleRedirectToNext() {
        // get router query
        const nextQuery = { ...router.query };
        delete nextQuery.next; // TODO: find better way of deleting next

        let url;
        if (!!router.query.next) {
            url = new URL(
                // @ts-ignore
                "https://example.com" + decodeURIComponent(router.query.next)
            );
            const params = new URLSearchParams(url.search);
            // @ts-ignore
            for (let p of params) {
                nextQuery[p[0]] = p[1];
            }
        }

        router.push({
            pathname: url && !!url ? url.pathname : "/plans",
            query: nextQuery,
        });
    }

    // redirect
    useEffect(() => {
        if (isAuthenticated && router.isReady) {
            handleRedirectToNext();
        }
    }, [isAuthenticated, router.isReady]);
}
